/* Wise Angler Sample Bundle landing v3 (journey builder + v2 guide fallback).
   The guide connects to the Fast Bundle widget by reading it and adding data-wab-* attributes (highlight, tip, active).
   It scrolls the page and the widget's own pack list, and only when the shopper taps "Use <size>" picks a size the
   widget already offers. It never adds options, changes presets or touches cart logic. */
(function () {
  if (window.__wabInit) return; window.__wabInit = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var preview = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') || /preview_theme_id/.test(location.search);
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function norm(t) { return (t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function widget() { return $('[id^="rbr-container-element"]'); }
  function buyArea() { return widget() || $('.product-block__buy_buttons') || $('#wab-build'); }
  function headerOffset() {
    var h = 0;
    $$('.shopify-section-group-header-group, #shopify-section-header, sticky-header, .header-wrapper').forEach(function (el) {
      var cs = getComputedStyle(el), r = el.getBoundingClientRect();
      if ((cs.position === 'sticky' || cs.position === 'fixed') && r.top <= 1 && r.bottom > 0) h = Math.max(h, r.bottom);
    });
    return (h || 70) + 12;
  }
  /* ---------- reading the Fast Bundle widget ---------- */
  function items() { var w = widget(); return w ? $$('.rbr-sbap_item', w) : []; }
  function itemTitle(it) { var a = $('.rbr-productNamePrice__title__container', it) || $('a', it); return a ? a.textContent.trim() : ''; }
  function findItem(title) {
    var want = norm(title), list = items(), i, t;
    for (i = 0; i < list.length; i++) { t = norm(itemTitle(list[i])); if (t === want) return list[i]; }
    for (i = 0; i < list.length; i++) { t = norm(itemTitle(list[i])); if (t && (t.indexOf(want) === 0 || want.indexOf(t) === 0)) return list[i]; }
    return null;
  }
  function scrollBox(it) {
    var w = widget(), sc = it && it.parentElement;
    while (sc && sc !== w) { var oy = getComputedStyle(sc).overflowY; if ((oy === 'auto' || oy === 'scroll') && sc.scrollHeight > sc.clientHeight) return sc; sc = sc.parentElement; }
    return null;
  }
  function pageTo(el, extra) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - (extra || 0);
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  }
  function reveal(it) {
    var sc = scrollBox(it), w = widget();
    if (sc) { sc.scrollTo({ top: sc.scrollTop + it.getBoundingClientRect().top - sc.getBoundingClientRect().top - 14, behavior: reduce ? 'auto' : 'smooth' }); pageTo(w); }
    else pageTo(it, 10);
  }
  function focusSel(it) {
    var s = it && $('select', it);
    if (s) setTimeout(function () { try { s.focus({ preventScroll: true }); } catch (e) { s.focus(); } }, reduce ? 30 : 650);
  }
  function optFor(sel, size) {
    if (!sel || !size) return null;
    var want = norm(size), opts = sel.options;
    for (var i = 0; i < opts.length; i++) {
      var t = norm(opts[i].text);
      if (opts[i].value && !opts[i].disabled && (t === want || t.indexOf(want + ' ') === 0)) return opts[i];
    }
    return null;
  }
  function pick(sel, opt) {
    /* exactly what a shopper choosing that option does: native value setter + bubbling change event (React-controlled select) */
    var setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
    setter.call(sel, opt.value);
    sel.dispatchEvent(new Event('input', { bubbles: true }));
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  /* ---------- guide data ---------- */
  var data = { guides: [], packTips: [] }, tips = {};
  try { var j = $('[data-wab-guides]'); if (j) data = JSON.parse(j.textContent); } catch (e) {}
  (data.packTips || []).forEach(function (l) { var p = l.split('::'); if (p.length > 1) tips[norm(p[0])] = p.slice(1).join('::').trim(); });
  if (data.previewSizes) preview = true;
  function guideById(id) { for (var i = 0; i < data.guides.length; i++) if (data.guides[i].id === id) return data.guides[i]; return null; }
  function packTip(title) {
    var n = norm(title);
    if (tips[n]) return tips[n];
    for (var k in tips) if (tips.hasOwnProperty(k) && (n.indexOf(k) === 0 || k.indexOf(n) === 0)) return tips[k];
    return '';
  }
  /* ---------- guide ---------- */
  var G = null, bar = null, mo = null;
  function el(k) { return bar && $('[data-wab-gb-' + k + ']', bar); }
  function buildSteps(g) {
    var steps = [], used = [];
    g.products.forEach(function (t, i) {
      var it = findItem(t); if (!it || used.indexOf(it) > -1) return;
      var line = (g.steps[i] || '').split('::'), tip = (line[0] || '').trim(), size = (line[1] || '').trim();
      steps.push({ it: it, title: itemTitle(it) || t, tip: tip || packTip(t), size: size, rec: true }); used.push(it);
    });
    items().forEach(function (it) {
      if (used.indexOf(it) > -1) return;
      steps.push({ it: it, title: itemTitle(it), tip: packTip(itemTitle(it)), size: '', rec: false }); used.push(it);
    });
    return steps;
  }
  function sizeAdvice(s) {
    if (!s.size) return null;
    var ok = !!G.g.sizesConfirmed;
    if (!ok && !preview) return null;
    var sel = $('select', s.it), o = optFor(sel, s.size);
    if (!o) return null;                       /* never suggest a size the widget does not offer */
    return { label: s.size, opt: o, sel: sel, confirm: !ok };
  }
  function mark() {
    if (!G) return;
    G.steps.forEach(function (s, i) {
      var it = s.it;
      if (!document.contains(it)) { var n = findItem(s.title); if (n) s.it = it = n; else return; }
      if (s.rec) { it.setAttribute('data-wab-rec', ''); it.setAttribute('data-wab-badge', 'Pick for ' + G.g.title); }
      var sel = $('select', it);
      if (sel && sel.value) it.setAttribute('data-wab-done', ''); else it.removeAttribute('data-wab-done');
      if (i === G.i) {
        it.setAttribute('data-wab-active', '');
        var tip = s.tip || 'Choose any size for this pack.';
        var sug = sizeAdvice(s);
        if (sug) tip += '\nSuggested: ' + sug.label + (sug.confirm ? ' (CONFIRM, preview only)' : '');
        if (!sel) tip += '\nOne size: included as is.';
        if (it.getAttribute('data-wab-tip') !== tip) it.setAttribute('data-wab-tip', tip);
      } else { it.removeAttribute('data-wab-active'); it.removeAttribute('data-wab-tip'); }
    });
  }
  function progress() {
    var sels = items().map(function (it) { return $('select', it); }).filter(Boolean);
    return { done: sels.filter(function (s) { return !!s.value; }).length, total: sels.length };
  }
  function render() {
    if (!G) return;
    var s = G.steps[G.i], sel = $('select', s.it), p = progress();
    el('guide').textContent = G.g.title + ' guide';
    el('n').textContent = G.i + 1; el('total').textContent = G.steps.length;
    el('title').textContent = s.title + (s.rec ? '' : ' (also in your bundle)');
    el('tip').textContent = s.tip || 'Choose any size for this pack.';
    var chosen = sel && sel.value ? sel.options[sel.selectedIndex].text : '';
    el('status').textContent = (sel ? (chosen ? '✓ ' + chosen + ' chosen. ' : 'Choose a size in the menu above. ') : 'One size, included. ') + p.done + ' of ' + p.total + ' size menus done.';
    el('progress').style.width = (p.total ? Math.round(p.done * 100 / p.total) : 0) + '%';
    el('prev').disabled = G.i === 0;
    el('next').textContent = G.i === G.steps.length - 1 ? 'Review & add ›' : 'Next pack ›';
    var sb = el('size'), sug = sizeAdvice(s);
    if (sug && sug.opt.value !== (sel && sel.value)) {
      sb.hidden = false; sb.textContent = 'Use ' + sug.label;
      if (sug.confirm) { var n = document.createElement('span'); n.className = 'wab-note-inline'; n.textContent = 'CONFIRM'; sb.appendChild(n); }
    } else sb.hidden = true;
    mark();
  }
  function go(i) {
    if (!G) return;
    G.i = Math.max(0, Math.min(G.steps.length - 1, i));
    render(); reveal(G.steps[G.i].it); focusSel(G.steps[G.i].it);
  }
  function clearMarks() {
    items().forEach(function (it) { ['data-wab-rec', 'data-wab-badge', 'data-wab-active', 'data-wab-tip', 'data-wab-done'].forEach(function (a) { it.removeAttribute(a); }); });
  }
  function stop() {
    clearMarks(); G = null; if (bar) bar.hidden = true;
    document.documentElement.classList.remove('wab-guiding');
    if (mo) { mo.disconnect(); mo = null; }
  }
  function start(id, title) {
    var g = guideById(id);
    if (B && g) { bStart(g, title); return; }
    if (!g || !widget()) { var b = buyArea(); if (b) pageTo(b); return; }
    clearMarks();
    G = { g: g, steps: buildSteps(g), i: 0 };
    if (!G.steps.length) { G = null; return; }
    var at = 0;
    if (title) { var it = findItem(title); G.steps.forEach(function (s, i) { if (s.it === it) at = i; }); }
    bar = $('[data-wab-guidebar]'); if (bar) bar.hidden = false;
    document.documentElement.classList.add('wab-guiding');
    if ('MutationObserver' in window && !mo) {
      var t; mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { if (G) render(); }, 80); });
      mo.observe(widget(), { childList: true, subtree: true });
    }
    go(at);
  }
  function finish() {
    var f = $('.rbr-bap-new-footer') || $('.product-form__buttons');
    stop();
    if (f) { pageTo(f, Math.round(window.innerHeight * 0.35)); f.setAttribute('data-wab-pulse', ''); setTimeout(function () { f.removeAttribute('data-wab-pulse'); }, 4500); }
  }

  /* ---------- v3 journey builder ----------
     A step-by-step layer that drives Fast Bundle's own selects and Add to cart button. Chips are built only from the
     options in the widget's select menus. Picking a chip sets that select exactly like a shopper would, so SKU,
     presets, sizes and cart result stay Fast Bundle's. The widget stays mounted underneath (visually hidden).
     If the widget can't be found, the builder never mounts and the original widget shows as normal. */
  var prices = { packs: [] }, priceById = {}, priceByTitle = {}, imgByTitle = {};
  try { var pj = $('[data-wab-prices]'); if (pj) prices = JSON.parse(pj.textContent); } catch (e) {}
  (prices.packs || []).forEach(function (p) { var ids = Object.keys(p.v || {}); ids.forEach(function (id) { priceById[id] = p.v[id]; }); priceByTitle[norm(p.t)] = ids.length === 1 ? p.v[ids[0]] : null; if (p.i) imgByTitle[norm(p.t)] = p.i; });
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function h(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function splitOpt(t) { t = t.replace(/\s+/g, ' ').trim(); var m = t.match(/^(.*?)[\s-]*(QTY.*)$/i); return m ? { s: m[1].trim(), q: m[2].trim() } : { s: t, q: '' }; }
  var B = null;
  function bItem(st) { return findItem(st.title); }
  function bImg(st) {
    /* product photo from Shopify (same image the widget uses); falls back to the widget's own img */
    var u = imgByTitle[norm(st.title)]; if (u) return u;
    var it = bItem(st), im = it && $('img', it); return im ? (im.getAttribute('data-src') || im.currentSrc || im.src) : '';
  }
  function bChosen(st) { var it = bItem(st), sel = it && $('select', it); return !!it && (!sel || !!sel.value); }
  function bValue(st) {
    var it = bItem(st), sel = it && $('select', it);
    if (!it) return 0;
    if (!sel) return priceByTitle[norm(st.title)] || 0;
    return sel.value ? (priceById[sel.value] || 0) : 0;
  }
  function bSteps(g) {
    if (g) return buildSteps(g).map(function (s) { return { title: s.title, tip: s.tip, size: s.size, rec: s.rec }; });
    return items().map(function (it) { var t = itemTitle(it); return { title: t, tip: packTip(t), size: '', rec: false }; });
  }
  function bSug(st) {
    if (!B.guide || !st.size) return null;
    var ok = !!B.guide.sizesConfirmed; if (!ok && !preview) return null;
    var it = bItem(st), o = optFor(it && $('select', it), st.size);
    return o ? { opt: o, confirm: !ok } : null;
  }
  function bMount() {
    var w = widget(); if (!w || !w.parentNode || !items().length || B) return false;
    var root = h('div', 'wabb'); root.setAttribute('data-wabb', ''); root.id = 'wab-builder';
    root.innerHTML = '<div class="wabb-head"><p class="wabb-k">Your bundle, step by step</p><p class="wabb-count" aria-live="polite"></p></div>' +
      '<div class="wabb-bar" aria-hidden="true"><span></span></div><div class="wabb-guide" hidden><span></span><button type="button" class="wabb-gx" aria-label="Stop guide">✕</button></div>' +
      '<div class="wabb-strip" role="list"></div><div class="wabb-stage"></div>' +
      '<div class="wabb-sum"><span class="wabb-sum-l"></span><span class="wabb-sum-r"></span></div>' +
      '<button type="button" class="wabb-classic">Show the classic list</button>';
    w.parentNode.insertBefore(root, w);
    B = { root: root, i: 0, guide: null, steps: bSteps(null) };
    document.documentElement.classList.add('wabb-on');
    root.addEventListener('click', bClick);
    if ('MutationObserver' in window) { var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(bRender, 90); }).observe(w, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] }); }
    bRender();
    return true;
  }
  function bStrip() {
    var strip = $('.wabb-strip', B.root); strip.textContent = '';
    B.steps.forEach(function (st, i) {
      var img = bImg(st), b = h('button', 'wabb-th');
      b.type = 'button'; b.setAttribute('role', 'listitem'); b.setAttribute('data-go', i);
      b.setAttribute('aria-label', (i + 1) + '. ' + st.title + (bChosen(st) ? ' (chosen)' : ''));
      if (i === B.i) b.setAttribute('aria-current', 'step');
      if (bChosen(st)) b.classList.add('is-done'); if (st.rec) b.classList.add('is-rec');
      if (img) { var im = h('img'); im.src = img; im.alt = ''; im.loading = 'lazy'; b.appendChild(im); }
      strip.appendChild(b);
    });
    var rv = h('button', 'wabb-th wabb-th-rv', '✓'); rv.type = 'button'; rv.setAttribute('data-go', B.steps.length); rv.setAttribute('aria-label', 'Review and add to cart');
    if (B.i === B.steps.length) rv.setAttribute('aria-current', 'step');
    strip.appendChild(rv);
    var cur = strip.children[B.i];
    if (cur) strip.scrollTo({ left: Math.max(0, cur.offsetLeft - strip.clientWidth / 2 + cur.offsetWidth / 2), behavior: reduce ? 'auto' : 'smooth' });
  }
  function bCard(st, i) {
    var it = bItem(st), sel = it && $('select', it), img = bImg(st), card = h('div', 'wabb-card');
    var media = h('div', 'wabb-media'); if (img) { var im = h('img'); im.src = img; im.alt = st.title; media.appendChild(im); }
    if (st.rec && B.guide) media.appendChild(h('span', 'wabb-badge', 'Pick for ' + B.guide.title));
    card.appendChild(media);
    var body = h('div', 'wabb-body');
    body.appendChild(h('p', 'wabb-n', 'Pack ' + (i + 1) + ' of ' + B.steps.length + (B.guide && !st.rec ? ' · also in your bundle' : '')));
    body.appendChild(h('h3', 'wabb-t', st.title));
    if (st.tip) body.appendChild(h('p', 'wabb-tip', st.tip));
    var chips = h('div', 'wabb-chips'); chips.setAttribute('role', 'group'); chips.setAttribute('aria-label', 'Size for ' + st.title);
    var sug = bSug(st);
    if (sel) {
      Array.prototype.forEach.call(sel.options, function (o) {
        if (!o.value || o.disabled) return;
        var so = splitOpt(o.text), c = h('button', 'wabb-chip'); c.type = 'button'; c.setAttribute('data-v', o.value);
        c.setAttribute('aria-pressed', String(sel.value === o.value)); if (sel.value === o.value) c.appendChild(h('i', 'wabb-tick', '✓'));
        c.appendChild(h('b', '', so.s)); if (so.q) c.appendChild(h('small', '', so.q.replace(/^QTY\s*/i, 'Qty ')));
        if (sug && sug.opt === o) { c.classList.add('is-sug'); c.appendChild(h('em', '', sug.confirm ? 'Suggested · CONFIRM' : 'Suggested')); }
        chips.appendChild(c);
      });
    } else chips.appendChild(h('p', 'wabb-one', '✓ One size, included as is'));
    body.appendChild(chips);
    var nav = h('div', 'wabb-nav'), bk = h('button', 'wabb-btn wabb-ghost', '‹ Back'), nx = h('button', 'wabb-btn wabb-next', i === B.steps.length - 1 ? 'Review my bundle ›' : 'Next pack ›');
    bk.type = nx.type = 'button'; bk.setAttribute('data-go', i - 1); nx.setAttribute('data-go', i + 1); bk.disabled = i === 0;
    nav.appendChild(bk); nav.appendChild(nx); body.appendChild(nav);
    card.appendChild(body);
    return card;
  }
  function bReview() {
    var box = h('div', 'wabb-review'); box.appendChild(h('h3', 'wabb-t', 'Review your bundle'));
    var ul = h('ul', 'wabb-list'), miss = -1, total = 0;
    B.steps.forEach(function (st, i) {
      var it = bItem(st), sel = it && $('select', it), li = h('li'), img = bImg(st);
      if (img) { var im = h('img'); im.src = img; im.alt = ''; li.appendChild(im); }
      var tx = h('span', 'wabb-li-t', st.title); li.appendChild(tx);
      var ok = bChosen(st); if (!ok && miss < 0) miss = i; total += bValue(st);
      var sz = h('button', 'wabb-li-s' + (ok ? '' : ' is-miss'), ok ? (sel ? splitOpt(sel.options[sel.selectedIndex].text).s : 'One size') : 'Choose size');
      sz.type = 'button'; sz.setAttribute('data-go', i); sz.setAttribute('aria-label', (ok ? 'Change size for ' : 'Choose size for ') + st.title); li.appendChild(sz);
      ul.appendChild(li);
    });
    box.appendChild(ul);
    var add = h('button', 'wabb-btn wabb-add', miss < 0 ? 'Add bundle to cart' : 'Choose the remaining sizes'); add.type = 'button';
    add.setAttribute(miss < 0 ? 'data-add' : 'data-go', miss < 0 ? '' : miss);
    if (miss < 0 && B.adding) { add.disabled = true; add.textContent = 'Adding…'; }
    if (miss < 0 && B.added) { add.textContent = '✓ Added to your cart'; add.removeAttribute('data-add'); add.disabled = true; }
    box.appendChild(add);
    if (miss < 0 && B.added) { var a = h('a', 'wabb-btn wabb-cartlink', 'View cart & checkout'); a.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart'; box.appendChild(a); }
    box.appendChild(h('p', 'wabb-fine', 'Quality tackle at wholesale price. Every pack 100% plastic-free.'));
    return box;
  }
  function bRender() {
    if (!B) return;
    if (!document.contains(B.root)) { B = null; document.documentElement.classList.remove('wabb-on'); return; }
    if (!widget() || !items().length) return;
    var done = B.steps.filter(bChosen).length, n = B.steps.length, val = B.steps.reduce(function (a, st) { return a + bValue(st); }, 0);
    $('.wabb-count', B.root).textContent = done + ' of ' + n + ' chosen'; B.root.classList.toggle('is-complete', done === n);
    $('.wabb-bar span', B.root).style.width = Math.round(done * 100 / n) + '%';
    var gl = $('.wabb-guide', B.root); gl.hidden = !B.guide; if (B.guide) $('span', gl).textContent = B.guide.title + ' guide: recommended packs first';
    var stage = $('.wabb-stage', B.root), focusKey = document.activeElement && B.root.contains(document.activeElement) ? (document.activeElement.getAttribute('data-v') || document.activeElement.className) : null;
        stage.textContent = ''; stage.appendChild(B.i >= n ? bReview() : bCard(B.steps[B.i], B.i));
    if (B.anim) { stage.firstChild.classList.add(B.dir < 0 ? 'is-in-prev' : 'is-in'); B.anim = false; }
    if (focusKey) try { var f = $('[data-v="' + focusKey + '"]', stage) || stage.querySelector('.' + String(focusKey).split(' ').join('.')); if (f) f.focus({ preventScroll: true }); } catch (e) {}
    bStrip();
    /* totals: RRP = sum of the real variant prices of the sizes chosen (unchosen packs count at the widget's default first
       size, as Fast Bundle does); bundle price = RRP x (product price / compare-at), i.e. the bundle's real discount.
       Falls back to Fast Bundle's own price display if price data is missing. */
    var sl = $('.wabb-sum-l', B.root), sr = $('.wabb-sum-r', B.root), w = widget(), rrp = 0, ok = !!(prices.bundle && prices.compare);
    B.steps.forEach(function (st) {
      var it = bItem(st), sel = it && $('select', it), v = 0;
      if (!it) { ok = false; return; }
      if (!sel) v = priceByTitle[norm(st.title)] || 0;
      else { var o = sel.value ? sel.options[sel.selectedIndex] : Array.prototype.filter.call(sel.options, function (x) { return x.value; })[0]; v = o ? (priceById[o.value] || 0) : 0; }
      if (!v) ok = false; rrp += v;
    });
    var pay;
    if (ok) { rrp = rrp / 100; pay = Math.round(rrp * prices.bundle / prices.compare * 100) / 100; }
    else {
      var m = w ? $$('.money', w).filter(function (e) { return !e.closest('.rbr-sbap_item') && /\d/.test(e.textContent); }).map(function (e) { return parseFloat(e.textContent.replace(/[^0-9.]/g, '')); }) : [];
      if (m.length >= 2 && m[0] > m[m.length - 1]) { rrp = m[0]; pay = m[m.length - 1]; ok = true; }
    }
    if (ok && rrp > pay) {
      sl.textContent = (done === n ? 'Your bundle: ' : 'Current bundle price: ') + '$' + pay.toFixed(2) + ' (RRP $' + rrp.toFixed(2) + ')';
      sr.textContent = 'You save $' + (rrp - pay).toFixed(2) + ' (' + Math.round((rrp - pay) * 100 / rrp) + '%)';
    } else { sl.textContent = done ? 'Your picks so far are worth ' + money(val) + ' RRP' : ''; sr.textContent = ''; }
  }
  function bGo(i, scroll) {
    var ni = Math.max(0, Math.min(B.steps.length, i)); B.dir = ni < B.i ? -1 : 1; B.i = ni; B.anim = !reduce; bRender();
    if (scroll) pageTo(B.root, 4);
    else { var r = B.root.getBoundingClientRect(); if (r.top < headerOffset() - 10) pageTo(B.root, 4); }
  }
  function bClick(e) {
    var t = e.target.closest('button'); if (!t || !B) return;
    if (t.hasAttribute('data-v')) {
      var st = B.steps[B.i], it = bItem(st), sel = it && $('select', it);
      var o = sel && Array.prototype.filter.call(sel.options, function (x) { return x.value === t.getAttribute('data-v'); })[0];
      if (o) { B.added = false; pick(sel, o); setTimeout(bRender, 60); if (!reduce) t.classList.add('is-pop'); }
      return;
    }
    if (t.hasAttribute('data-go')) { B.added = false; bGo(parseInt(t.getAttribute('data-go'), 10), false); return; }
    if (t.hasAttribute('data-add')) {
      var f = $('.rbr-bap-new-footer');
      if (!f) { document.documentElement.classList.add('wabb-showlist'); return; }
      B.adding = true; B.added = false; bRender();
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var count = function () { return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { return c.item_count; }); };
      var done = function (ok) { B.adding = false; B.added = ok; bRender(); };
      count().catch(function () { return -1; }).then(function (before) {
        f.click();                                /* Fast Bundle's own Add to cart does the work */
        if (before < 0) { setTimeout(function () { done(false); }, 5000); return; }
        var tries = 0, iv = setInterval(function () {
          count().then(function (now) {
            if (now > before) { clearInterval(iv); done(true); } else if (++tries > 10) { clearInterval(iv); done(false); }
          }).catch(function () { if (++tries > 10) { clearInterval(iv); done(false); } });
        }, 800);
      });
      return;
    }
    if (t.classList.contains('wabb-gx')) { B.guide = null; B.steps = bSteps(null); bGo(0, false); return; }
    if (t.classList.contains('wabb-classic')) { var on = document.documentElement.classList.toggle('wabb-showlist'); t.textContent = on ? 'Hide the classic list' : 'Show the classic list'; }
  }
  function bStart(g, title) {
    B.guide = g; B.steps = bSteps(g);
    var at = 0; if (title) { var tn = norm(itemTitle(findItem(title) || document.body) || title); B.steps.forEach(function (s, i) { if (norm(s.title) === tn) at = i; }); }
    bGo(at, true);
  }
  function bFirstMissing() { for (var i = 0; i < B.steps.length; i++) if (!bChosen(B.steps[i])) return i; return B.steps.length; }
  function bWait() {
    var n = 0, iv = setInterval(function () {
      var ok = false; try { ok = bMount(); } catch (e) { document.documentElement.classList.remove('wabb-on'); if (B && B.root) B.root.remove(); B = null; clearInterval(iv); return; }
      if (ok || ++n > 40) clearInterval(iv);
    }, 500);
  }

  /* ---------- v4 species knowledge hub + interactive hook cards ---------- */
  function hubInit() {
    var hubEl = $('[data-wab-hub]'); var cardsEl = $('.wab-cards');
    var cards = cardsEl ? $$('[data-wab-card]', cardsEl) : [];
    if (hubEl) {
      var tabs = $$('[role="tab"]', hubEl), wrap = $('.wab-hub-chips', hubEl);
      var match = function (tab) {
        var hooks = (tab.getAttribute('data-hooks') || '').split(',').filter(Boolean), name = tab.textContent.trim(), any = false;
        cards.forEach(function (c) {
          var hit = (c.getAttribute('data-wab-card') || '').split(',').some(function (hd) { return hooks.indexOf(hd) > -1; });
          c.classList.toggle('is-match', hit); if (hit) { any = true; c.setAttribute('data-match', 'For ' + name); } else c.removeAttribute('data-match');
        });
        if (cardsEl) cardsEl.classList.toggle('has-match', any);
      };
      var track = $('[data-wab-hub-track]', hubEl), panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
      var mq = window.matchMedia ? matchMedia('(max-width: 749px)') : { matches: false };
      var countEl = $('.wab-hub-count b', hubEl), dotsEl = $('.wab-hub-dots', hubEl), curI = 0, lock = 0;
      if (dotsEl) tabs.forEach(function () { dotsEl.appendChild(h('i')); });
      var mark = function (i) {
        curI = i;
        tabs.forEach(function (t, j) { var on = j === i; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; if (panels[j]) panels[j].classList.toggle('is-on', on); });
        if (countEl) countEl.textContent = i + 1;
        if (dotsEl) $$('i', dotsEl).forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
        if (wrap && wrap.scrollWidth > wrap.clientWidth) wrap.scrollTo({ left: Math.max(0, tabs[i].offsetLeft - 20), behavior: reduce ? 'auto' : 'smooth' });
        match(tabs[i]);
      };
      var carousel = function () { return mq.matches && track; };
      var layout = function () {
        /* mobile: every card rendered in the swipe track; desktop: only the active panel */
        panels.forEach(function (pn, j) { if (pn) pn.hidden = carousel() ? false : j !== curI; });
        if (carousel()) track.scrollLeft = panels[curI] ? panels[curI].offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0) : 0;
      };
      var select = function (tab, focus) {
        var i = tabs.indexOf(tab);
        if (carousel()) {
          mark(i); lock = Date.now();
          var pn = panels[i]; if (pn) track.scrollTo({ left: pn.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: reduce ? 'auto' : 'smooth' });
          if (focus) tab.focus({ preventScroll: true });
          return;
        }
        mark(i);
        panels.forEach(function (pnl, j) { if (!pnl) return; var on = j === i; pnl.hidden = !on; pnl.classList.remove('is-anim'); if (on && !reduce) { void pnl.offsetWidth; pnl.classList.add('is-anim'); } });
        if (focus) tab.focus({ preventScroll: true });
      };
      if (track) {
        var raf = 0;
        track.addEventListener('scroll', function () {
          if (raf || !carousel()) return;
          raf = requestAnimationFrame(function () {
            raf = 0; if (Date.now() - lock < 700) return;          /* a chip tap is driving the scroll */
            var x = track.scrollLeft + track.clientWidth * 0.35, best = 0;
            panels.forEach(function (pn, j) { if (pn && pn.offsetLeft - track.offsetLeft <= x) best = j; });
            if (best !== curI) mark(best);
          });
        }, { passive: true });
        if (mq.addEventListener) mq.addEventListener('change', layout); else if (mq.addListener) mq.addListener(layout);
        $$('.wab-hub-more', hubEl).forEach(function (b) {
          b.addEventListener('click', function () {
            var pn = b.closest('.wab-hub-panel'), on = !pn.classList.contains('is-more');
            pn.classList.toggle('is-more', on); b.setAttribute('aria-expanded', String(on));
            $('.wab-hub-more-t', b).textContent = on ? 'Less' : 'More: how to fish, rig & tip';
          });
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, j = k === 'ArrowRight' ? i + 1 : k === 'ArrowLeft' ? i - 1 : k === 'Home' ? 0 : k === 'End' ? tabs.length - 1 : -2;
          if (j === -2) return; e.preventDefault(); select(tabs[(j + tabs.length) % tabs.length], true);
        });
      });
      var cur = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      if (cur) { curI = tabs.indexOf(cur); mark(curI); layout(); }
    }
    /* cards: hover/focus lift on desktop; tap toggles lift + "Best for" on touch */
    var touch = window.matchMedia && matchMedia('(hover: none)').matches;
    cards.forEach(function (c) {
      c.addEventListener('click', function (e) { if (!touch || e.target.closest('a,button')) return; var on = !c.classList.contains('is-open'); cards.forEach(function (x) { x.classList.remove('is-open'); }); c.classList.toggle('is-open', on); });
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.classList.toggle('is-open'); } });
    });
  }
  /* ---------- hero: pointer + scroll parallax (fine pointer only for the pointer part; off with reduced motion) ---------- */
  function heroMotion() {
    var fan = $('[data-wab-fan]'); if (!fan || reduce) return;
    var hero = fan.closest('.wab-hero'), raf = 0, px = 0, py = 0;
    function apply() { raf = 0; fan.style.setProperty('--px', px.toFixed(3)); fan.style.setProperty('--py', py.toFixed(3)); var r = hero.getBoundingClientRect(); fan.style.setProperty('--sy', Math.max(0, Math.min(400, -r.top)).toFixed(0) + 'px'); }
    function q() { if (!raf) raf = requestAnimationFrame(apply); }
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      hero.addEventListener('pointermove', function (e) { var r = hero.getBoundingClientRect(); px = ((e.clientX - r.left) / r.width - 0.5) * 2; py = ((e.clientY - r.top) / r.height - 0.5) * 2; q(); });
      hero.addEventListener('pointerleave', function () { px = py = 0; q(); });
    }
    window.addEventListener('scroll', q, { passive: true });
  }
  function init() {
    if (preview) $$('[data-wab]').forEach(function (r) { r.classList.add('wab-preview'); });
    heroMotion();
    /* hero is the first section now: the card deal plays on load (no scroll wait) */
    bWait();
    try { hubInit(); } catch (e) {}
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null; if (!t) return;
      var g = t.closest('[data-wab-guide]');
      if (g) { e.preventDefault(); start(g.getAttribute('data-wab-guide'), g.getAttribute('data-wab-item')); return; }
      var to = t.closest('[data-wab-to]');
      if (to) { var tg = document.getElementById(to.getAttribute('data-wab-to')); if (tg) { e.preventDefault(); pageTo(tg, 4); return; } }
      var a = t.closest('[data-wab-go]');
      if (a) {
        e.preventDefault();
        if (B) { bGo(bFirstMissing(), true); return; }
        var first = items().filter(function (it) { var s = $('select', it); return s && !s.value; })[0], w = widget();
        if (first) { reveal(first); focusSel(first); } else if (w) pageTo(w); else { var b = buyArea(); if (b) pageTo(b); }
        return;
      }
      if (!bar || !G) return;
      if (t.closest('[data-wab-gb-next]')) { if (G.i === G.steps.length - 1) finish(); else go(G.i + 1); }
      else if (t.closest('[data-wab-gb-prev]')) go(G.i - 1);
      else if (t.closest('[data-wab-gb-exit]')) stop();
      else if (t.closest('[data-wab-gb-size]')) { var s = G.steps[G.i], sg = sizeAdvice(s); if (sg) { pick(sg.sel, sg.opt); setTimeout(render, 80); } }
    });
    /* follow the shopper: a size chosen in any pack updates the guide (and moves it to that pack) */
    document.addEventListener('change', function (e) {
      if (!G || !e.target || e.target.tagName !== 'SELECT') return;
      var it = e.target.closest('.rbr-sbap_item'); if (!it) return;
      G.steps.forEach(function (s, i) { if (s.it === it) G.i = i; });
      setTimeout(render, 60);
    }, true);
    document.addEventListener('change', function (e) { if (B && e.target && e.target.closest && e.target.closest('.rbr-sbap_item')) setTimeout(bRender, 60); }, true);
    document.addEventListener('keydown', function (e) { if (G && e.key === 'Escape') stop(); });
    var chips = $$('[data-wab-chip]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { var on = x === c; x.setAttribute('aria-pressed', String(on)); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      });
    });
    // v17: finder = segmented toggle + swipeable photo tiles (tiles keep data-wab-chip, so the chip handler above swaps panels)
    var fx = $('[data-wab-fx]');
    if (fx) {
      var vp = $('[data-wab-tiles-vp]', fx), pv = $('[data-wab-tiles-prev]', fx), nx = $('[data-wab-tiles-next]', fx);
      var lis = $$('.wab-tile-li', fx), segs = $$('[data-wab-seg]', fx), last = {};
      var arrows = function () {
        if (!vp) return; var max = vp.scrollWidth - vp.clientWidth - 2;
        if (pv) pv.hidden = vp.scrollLeft <= 2; if (nx) nx.hidden = vp.scrollLeft >= max;
      };
      var step = function (dir) { var t = $('.wab-tile-li:not([hidden])', fx); var w = t ? t.getBoundingClientRect().width + 12 : 200; vp.scrollBy({ left: dir * Math.max(w, Math.floor(vp.clientWidth / w) * w - w), behavior: reduce ? 'auto' : 'smooth' }); };
      if (pv) pv.addEventListener('click', function () { step(-1); });
      if (nx) nx.addEventListener('click', function () { step(1); });
      if (vp) { vp.addEventListener('scroll', function () { window.requestAnimationFrame(arrows); }, { passive: true }); window.addEventListener('resize', arrows); }
      segs.forEach(function (sb) {
        sb.addEventListener('click', function () {
          var k = sb.getAttribute('data-wab-seg'); if (sb.getAttribute('aria-pressed') === 'true') return;
          var cur = $('.wab-tile[aria-pressed="true"]', fx); if (cur) last[cur.closest('.wab-tile-li').getAttribute('data-wab-kind')] = cur;
          segs.forEach(function (x) { x.setAttribute('aria-pressed', String(x === sb)); });
          lis.forEach(function (li) { li.hidden = li.getAttribute('data-wab-kind') !== k; });
          var pick = last[k] || $('.wab-tile-li[data-wab-kind="' + k + '"] .wab-tile', fx);
          if (pick) pick.click();
          if (vp) vp.scrollLeft = 0; arrows();
        });
      });
      arrows();
    }
    $$('[data-wab-faq]').forEach(function (f) { f.addEventListener('click', function (e) { if (e.target.closest('summary')) e.stopPropagation(); }, true); });
    var rv = $$('.wab-rv');
    if (!reduce && 'IntersectionObserver' in window) {
      var vh = window.innerHeight;
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.remove('wab-pre'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      rv.forEach(function (el) { if (el.getBoundingClientRect().top > vh) { el.classList.add('wab-pre'); io.observe(el); } });
      window.addEventListener('beforeprint', function () { rv.forEach(function (el) { el.classList.remove('wab-pre'); }); });
    }
    var st = $('[data-wab-sticky]');
    if (st && 'IntersectionObserver' in window) {
      var btn = $('button', st), heroOn = true, wOn = false, footOn = false;
      var upd = function () { var on = !heroOn && !wOn && !footOn; st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', String(!on)); if (btn) btn.tabIndex = on ? 0 : -1; };
      var hc = $('[data-wab-hero-cta]');
      if (hc) new IntersectionObserver(function (en) { en.forEach(function (x) { heroOn = x.isIntersecting || x.boundingClientRect.top > 0; }); upd(); }).observe(hc); else heroOn = false;
      var foot = $('.shopify-section-group-footer-group');
      if (foot) new IntersectionObserver(function (en) { en.forEach(function (x) { footOn = x.isIntersecting; }); upd(); }).observe(foot);
      var wio = new IntersectionObserver(function (en) { en.forEach(function (x) { wOn = x.isIntersecting; }); upd(); });
      var watched = null, tries = 0;
      var watchW = function () { var w = buyArea(); if (w && w !== watched) { if (watched) wio.unobserve(watched); watched = w; wio.observe(w); } };
      watchW(); var iv = setInterval(function () { watchW(); if (++tries > 20) clearInterval(iv); }, 1000);
      upd();
    }
    window.WAB = { builder: function () { return B && { i: B.i, n: B.steps.length, guide: B.guide && B.guide.title, title: B.steps[B.i] && B.steps[B.i].title }; }, start: start, stop: stop, state: function () { return G && { guide: G.g.title, i: G.i, n: G.steps.length, title: G.steps[G.i].title }; } };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
